import Divider from '#components/divider/Divider';
import Typography from '#components/typography/Typography';

type Props = {
  title: string;
  classes?: string;
};

const SectionTitle = ({ title, classes = '' }: Props) => {
  return (
    <div className={`tw-max-w-page tw-mx-auto ${classes}`}>
      <Typography variant="h3" element="h3" classes="tw-mb-1.5">
        {title}
      </Typography>
      <Divider classes="tw-mb-8" />
    </div>
  );
};

export default SectionTitle;
